import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { NavLink } from "react-router-dom";

import clsx from "clsx";

import { Button, Tooltip } from "@mui/material";

import collapseIcon from "assets/images/sidebarHeader/navigation.svg";
import collapseBackIcon from "assets/images/sidebarHeader/navigationBack.svg";
import logo from "assets/images/sidebarHeader/larochelle-logo-white.png";

import {
  setSidebarToggle,
  setSidebarToggleMobile,
} from "features/sidebarSlice";

const SidebarHeader = () => {
  const { sidebarToggleMobile, sidebarToggle } = useSelector(
    (state) => state.sidebar,
  );

  const dispatch = useDispatch();

  const toggleSidebarMobile = () => {
    dispatch(setSidebarToggleMobile(!sidebarToggleMobile));
  };
  const toggleSidebar = () => {
    dispatch(setSidebarToggle(!sidebarToggle));
  };

  useEffect(() => {
    if (sidebarToggleMobile) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [sidebarToggleMobile]);

  return (
    <>
      <div className="app-sidebar--header">
        <div className="app-sidebar-logo">
          <NavLink
            to="/"
            title="Bamburgh React Admin Dashboard with Material-UI PRO"
            className="app-sidebar-logo"
          >
            <div className="app-sidebar-logo--icon">
              <img src={logo} alt="Logo" />
            </div>
          </NavLink>
        </div>
        <div className="app-sidebar-collapsed-logo" style={{ display: "none" }}>
          <img src={logo} alt="logo" />
        </div>
        <Tooltip title="Collapse sidebar" placement="right" arrow>
          <Button
            onClick={toggleSidebar}
            className="btn btn-sm collapse-sidebar-btn"
          >
            <div className="collapse-sidebar-icon-field">
              <img
                src={collapseIcon}
                alt="Collapse"
                className="collapse-sidebar-icon"
              />
            </div>
          </Button>
        </Tooltip>
        <Button
          className={clsx(
            "navbar-toggler hamburger hamburger--elastic toggle-mobile-sidebar-btn",
            { "is-active": sidebarToggleMobile },
          )}
          onClick={toggleSidebarMobile}
        >
          <span className="hamburger-box">
            <span className="hamburger-inner" />
          </span>
        </Button>
        <Tooltip title="Expand sidebar" placement="right" arrow>
          <Button
            onClick={toggleSidebar}
            className="expand-sidebar-btn btn btn-sm"
          >
            <div className="collapse-sidebar-icon-field">
              <img
                src={collapseBackIcon}
                alt="Collapse"
                className="collapse-sidebar-icon"
              />
            </div>
          </Button>
        </Tooltip>
      </div>
    </>
  );
};

export default SidebarHeader;
